import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export enum StatusLabelEnum {
  active = 'active',
  resolved = 'resolved',
  inactive = 'inactive',
  disabled = 'disabled',
  failed = 'failed',
  failure = 'failure',
  error = 'error',
  pendingDeletion = 'pending deletion',
  deleted = 'deleted',
  open = 'open',
  exempted = 'exempted',
  warning = 'warning',
  success = 'success',
  inProgress = 'inProgress',
  blocked = 'blocked',
  detected = 'detected',
  connected = 'connected',
  disconnected = 'disconnected',
}

@Component({
  selector: 'app-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss'],
})
export class StatusLabelComponent implements OnChanges {
  @Input() public statusLabel: string;
  @Input() public statusDescription?: string;
  @Input() public statusTooltip?: string;
  @Input() public disabled?: boolean = false;

  public icon = '';
  public cssClass = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statusLabel'] || changes['disabled']) {
      this.icon = this._getIconPath();
      this.cssClass = this._getClassStatus() + (this.disabled ? ' disabled' : '');
    }
  }

  private _getIconPath(): string {
    switch (this.statusLabel) {
      case StatusLabelEnum.active:
      case StatusLabelEnum.resolved:
      case StatusLabelEnum.success:
      case StatusLabelEnum.connected:
        return 'assets/images/status-icons/healthy.svg';
      case StatusLabelEnum.exempted:
        return 'assets/images/status-icons/info.svg';
      case StatusLabelEnum.inactive:
      case StatusLabelEnum.disabled:
        return 'assets/images/status-icons/inactive.svg';
      case StatusLabelEnum.failed:
      case StatusLabelEnum.failure:
      case StatusLabelEnum.error:
      case StatusLabelEnum.disconnected:
        return 'assets/images/status-icons/fail.svg';
      case StatusLabelEnum.blocked:
        return 'assets/images/dataflow-icons/blocked.svg';
      case StatusLabelEnum.pendingDeletion:
        return 'assets/images/status-icons/pendingDeletion.svg';
      case StatusLabelEnum.deleted:
        return 'assets/images/status-icons/deleted.svg';
      case StatusLabelEnum.open:
      case StatusLabelEnum.warning:
        return 'assets/images/status-icons/attention.svg';
      case StatusLabelEnum.detected:
        return 'assets/images/dataflow-icons/shield-alert.svg';
      case StatusLabelEnum.inProgress:
        return 'assets/images/status-icons/eye.svg';
      default:
        return '';
    }
  }

  private _getClassStatus(): string {
    switch (this.statusLabel) {
      case StatusLabelEnum.active:
      case StatusLabelEnum.resolved:
      case StatusLabelEnum.success:
      case StatusLabelEnum.connected:
        return 'healthy';
      case StatusLabelEnum.exempted:
      case StatusLabelEnum.inactive:
      case StatusLabelEnum.disabled:
        return 'neutral';
      case StatusLabelEnum.failed:
      case StatusLabelEnum.failure:
      case StatusLabelEnum.error:
      case StatusLabelEnum.blocked:
      case StatusLabelEnum.disconnected:
        return 'error';
      case StatusLabelEnum.pendingDeletion:
        return 'pendingDeletion';
      case StatusLabelEnum.deleted:
        return 'deleted';
      case StatusLabelEnum.open:
      case StatusLabelEnum.warning:
        return 'warning';
      case StatusLabelEnum.detected:
        return 'detected';
      case StatusLabelEnum.inProgress:
        return 'info';
      default:
        return '';
    }
  }
}
